var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ad",staticClass:"text-center",class:{
    'sidearm-dfp-ad': _vm.location && _vm.location.sidearm_dfp,
    'dfp-ad': _vm.location && !_vm.location.sidearm_dfp
  }},[_c('div',{staticClass:"sidearm-dfp-ad__inner",style:({
      width: (_vm.width + "px"),
      height: _vm.height === 0 ? 'auto' : (_vm.height + "px")
    }),attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }